@for (item of dataSource$ | async; track item) {
    <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{entity:item}">
    </ng-container>
}

@if (noDataCheck) {
    <div class="no-data">
        {{ 'ui.grid.message.lack-of-results' | translate }}
    </div>
}